import React from "react";
import { CaseDocumentsHome } from "../components";

const Cnt_CaseDocuments: React.FC = (props) => {

  return <CaseDocumentsHome {...props} />;
};

export default Cnt_CaseDocuments;
